<template>
  <BaseForm
    :key="cropId || 'new'"
    :title="formTitle"
    :formData="cropData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    cropId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      cropData: {
        crop: null,
        season: null
      },
      fields: [
        { model: 'crop', label: 'Crop Name', required: true, type: 'text' },
        { model: 'season', label: 'Season', type: 'text' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.cropId ? `Edit Crop` : 'Add Crop';
    },
    submitUrl() {
      return this.cropId ? `/api/v1/crop/crops/${this.cropId}/` : '/api/v1/crop/crops/';
    },
    method() {
      return this.cropId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.cropId) {
      this.loadCropData();
    } else {
      this.cropData = {
        crop: '',
        season: ''
      }
    }
  },
  methods: {
    loadCropData() {
      axios.get(this.submitUrl).then(response => {
        this.cropData = response.data;
      }).catch(
        console.error
      );
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Crop saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.log(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the crop!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
